import { Injectable } from '@angular/core';
@Injectable()
export class UserPlanService {

  constructor() { }

  userPlan;
  builingsUserDetails : any;
  builingManagerExists : any;
  pricingPageError;
  changeBuildByRes : any;

  setUserPlan(plan){
     this.userPlan = plan;
  }

  getUserPlan(){
     return this.userPlan;
  }

  setUserData(data){
     this.builingsUserDetails = data;
  }

  getUserData(){
     return this.builingsUserDetails;
  }

  resetUserPlan(){
     this.userPlan = null;
     this.builingsUserDetails = null;
     this.changeBuildByRes = {status : "", currentBuildingPlaceId : ""};
     sessionStorage.removeItem('buildingImage');
     localStorage.removeItem('buildingImage');
     sessionStorage.removeItem('userImage');
     localStorage.removeItem('userImage');
     localStorage.removeItem('facebookImage');
  }

  setBuildingManagerExists(status){
      this.builingManagerExists = status;
  }

  getBuildingManagerExists(){
      return this.builingManagerExists;
  }

  setError(error){
    this.pricingPageError = error;
  }

  getError(){
    return this.pricingPageError;
  }

  setchangeBuildingByRes(change){
       this.changeBuildByRes = change;
  }
  getchangeBuildingByRes(){
      return this.changeBuildByRes;
  }
}
